<template>
  <div>
    <toolbar />
    <div class="containerFull">
      <headerbar />
      <br />
      <form @submit.prevent="submitForm">
        <div class="form-col">
          <div class="content-step">
            <div class="form-group col-md-12">
              <h4>Informações do Email</h4>
              <label for="head">Assunto do Email:</label>
              <textarea
                class="form-control"
                rows="3"
                v-model="emailProperties.textSubjectEmail"
              ></textarea>
              <p
                class="warning"
                v-if="
                  !emailProperties.textSubjectEmail
                    .replace(/<[^>]+>/g, '')
                    .trim()
                "
              >
                Este campo é obrigatório, não pode estar vazio.
              </p>
              <br />
              <p class="warning-format">
                [username] é um palavra chave, ao usa-la, ela será substituída
                pelo nome do solicitante.<br />
                <span class="important"
                  >Deve estar sempre dentro de colchetes para o efeito correto.
                  desta forma: [username]</span
                >
              </p>
              <label for="head">Texto do Cabeçalho:</label>
              <vue-editor
                class="editor"
                v-model="emailProperties.textHeadEmail"
                :editor-toolbar="customBaseToolbar"
              ></vue-editor>
              <p
                class="warning"
                v-if="
                  !emailProperties.textHeadEmail.replace(/<[^>]+>/g, '').trim()
                "
              >
                Este campo é obrigatório, não pode estar vazio.
              </p>

              <label for="body">Texto do corpo do Email:</label>
              <vue-editor
                class="editor"
                v-model="emailProperties.textBodyEmail"
                id="body"
                :editor-toolbar="customToolbar"
              ></vue-editor>
              <p
                class="warning"
                v-if="
                  !emailProperties.textBodyEmail.replace(/<[^>]+>/g, '').trim()
                "
              >
                Este campo é obrigatório, não pode estar vazio.
              </p>
              <label for="proposal">Texto da proposta</label>
              <vue-editor
                v-model="emailProperties.textProposalEmail"
                class="editor"
                id="proposal"
                :editor-toolbar="customBaseToolbar"
              ></vue-editor>
              <p
                class="warning"
                v-if="
                  !emailProperties.textProposalEmail
                    .replace(/<[^>]+>/g, '')
                    .trim()
                "
              >
                Este campo é obrigatório, não pode estar vazio.
              </p>
              <label for="budget">Texto do orçamento:</label>
              <vue-editor
                v-model="emailProperties.textBudgetEmail"
                class="editor"
                id="budget"
                :editor-toolbar="customBaseToolbar"
              ></vue-editor>
              <p
                class="warning"
                v-if="
                  !emailProperties.textBudgetEmail
                    .replace(/<[^>]+>/g, '')
                    .trim()
                "
              >
                Este campo é obrigatório, não pode estar vazio.
              </p>
            </div>
            <button
              :disabled="isButtonDisabled"
              type="submit"
              class="save btn btn-primary"
            >
              Salvar
            </button>
          </div>
        </div>
      </form>
      <div class="content-test">
        <input
          v-model="emailProperties.senderEmail"
          id="email"
          class="email-input"
          type="email"
          placeholder="Email"
        />
        <button
          :disabled="isButtonDisabled && invalidEmail"
          @click="sendTest"
          class="send btn btn-primary"
        >
          Enviar Teste
        </button>
      </div>
      <p style="display: block" class="warning" v-if="invalidEmail">
        Este não é um email válido
      </p>

      <br />
    </div>
  </div>
</template>

<script>
import Headerbar from "@/components/Nav/Headerbar";
import Toolbar from "@/components/Nav/Toolbar";
import { VueEditor } from "vue2-editor";
import { removeEmptySpaces } from "../../Utils/removeEmptySpaces";

export default {
  name: "dashboard-edit-form",
  props: {},
  data() {
    return {
      customBaseToolbar: [
        ["bold", "italic", "underline"],
        [{ header: [1, 2, 3, false] }],
      ],
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ color: [] }, { background: [] }],
        [{ font: [] }],
        [{ align: [] }],
        [{ size: ["small", false, "large", "huge"] }],
      ],
    };
  },
  async created() {
    const response = await this.fetchContentEmail();
    if (response.status !== 200) {
      this.$swal({
        type: "error",
        title: ":/",
        text: `Houve um problema ao receber as informações.`,
        confirmButtonText: "Ok",
      });
    }
  },
  methods: {
    createDataToSend() {
      return {
        textHeadEmail: this.emailProperties.textHeadEmail,
        textBodyEmail: this.emailProperties.textBodyEmail,
        textProposalEmail: this.emailProperties.textProposalEmail,
        textBudgetEmail: this.emailProperties.textBudgetEmail,
        textSubjectEmail: this.emailProperties.textSubjectEmail,
      };
    },
    async sendData() {
      const dataToSend = removeEmptySpaces(this.createDataToSend());
      try {
        const response = await this.patchContentEmail(dataToSend);
        if (response.status === 200) {
          this.$swal({
            type: "success",
            title: ":)",
            text: `Alterações realizadas com sucesso`,
            confirmButtonText: "Ok",
          });
        } else {
          this.$swal({
            type: "error",
            title: ":/",
            text: `Ocorreu um erro no envio`,
            confirmButtonText: "Ok",
          });
        }
      } catch (error) {
        console.error(error);
      }
    },
    async sendTest() {
      const dataToSend = {
        ...this.createDataToSend(),
        senderEmail: this.emailProperties.senderEmail.trim(),
      };
      try {
        const response = await this.postTestContentEmail(dataToSend);
        if (response.status === 200) {
          this.$swal({
            type: "success",
            title: ":)",
            text: `Um exemplo do template foi enviado para ${this.senderEmail}`,
            confirmButtonText: "Ok",
          });
        } else {
          this.$swal({
            type: "error",
            title: ":/",
            text: `Ocorreu um erro no envio`,
            confirmButtonText: "Ok",
          });
        }
      } catch (error) {
        console.error(error);
      }
    },
    submitForm() {
      this.sendData();
    },
    async fetchContentEmail() {
      return await this.$store.dispatch("email/fetchContentEmail");
    },
    async patchContentEmail(data) {
      return await this.$store.dispatch("email/patchContentEmail", data);
    },
    async postTestContentEmail(data) {
      return await this.$store.dispatch("email/postTestContentEmail", data);
    },
  },
  computed: {
    invalidEmail() {
      const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/;
      return !emailRegex.test(this.emailProperties.senderEmail);
    },
    emailProperties() {
      return this.$store.state.email.emailProperties;
    },
    isButtonDisabled() {
      const properties = [
        "textHeadEmail",
        "textBodyEmail",
        "textProposalEmail",
        "textBudgetEmail",
        "textSubjectEmail",
      ];
      return properties.some(
        (prop) => removeEmptySpaces(this.emailProperties[prop]) === ""
      );
    },
  },
  components: {
    Toolbar,
    Headerbar,
    VueEditor,
  },
};
</script>
<style>
.warning {
  font-weight: 500;
  color: red;
  font-size: 16px;
}
.warning-format {
  font-weight: bold;
  color: #3c4c7c;
}
.important {
  color: red;
}
.content-test {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 900px;
}
.email-input {
  width: 100%;
  max-width: 600px;
  height: 38px;
  border: 1px solid gainsboro;
  border-radius: 4px;
  padding: 8px;
  margin: 0 5px 0 0;
}
.btn {
  width: 100%;
  max-width: 300px;
  height: 38px;
  font-size: 16px;
  font-weight: bold;
}
.editor .ql-editor {
  min-height: 0;
}
.content-step {
  background: #f3f3f3;
  padding: 30px;
  border-radius: 30px;
  margin-bottom: 25px;
}
.ql-editor {
  background-color: #ffffff;
}
label {
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Budgets/EditEmail.vue